<template>
  <section class='how-it-works'>
    <div class="flex-wrapper">
      <div class="content">
        <div class="content-wrap">
          <div class="group">
            <router-link
                class="menu-link"
                :to="{name: 'public.login'}"
            >
              <img :src="logo" alt="Broodje dunner logo">
            </router-link>
          </div>

          <div class="group">
            <h3>Niet toegestaan</h3>
          </div>

          <p class="light">
            Deze pagina kan om veiligheidsredenen niet worden geopend in een web browser. Download of open de Broodje
            Dunner app om verder te gaan.
          </p>

          <router-link
              class='btn wide'
              :to='{name: "public.login"}'
          >
            Terug naar inloggen
          </router-link>
        </div>
      </div>

      <div class="image">
        <img :src="image" alt="Login image for Broodje Dunner">
      </div>
    </div>
  </section>
</template>

<script>
import background from "@/assets/images/login-background.jpeg";
import logo from "@/assets/images/logo.svg";

export default {
  name: "How it works",
  data() {
    return {
      image: background,
      logo: logo,
    };
  },
};
</script>
